import helperStyles from "@src/components/helpers.module.scss";
import { buildPortalAssetUrl } from "@src/utils/portalAssets.utils";
import React from "react";

export const CIMS_TM = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<div className={helperStyles.textPrimary}>
				<img src={buildPortalAssetUrl("/images/tm-external-logo.png")} alt="CIMS" />
			</div>
		</div>
	);
};
